import { AdUnit, AdUnitLocation } from "@shared/models/AdUnit/AdUnit"
import axios from "axios"
import { route } from "ziggy-js"
import { captureException } from "@services/Sentry"

interface AdUnitSearchParams {
  location: AdUnitLocation
  taxonomy_path: string | undefined
}

interface PendingRequest {
  params: AdUnitSearchParams
  resolve: (value: AdUnit[]) => void
}

function createAdUnitSearchQueue(timeoutThreshold = 100) {
  let pendingRequests: PendingRequest[] = []
  let timeout: ReturnType<typeof setTimeout> | null = null

  function push(params: AdUnitSearchParams): Promise<AdUnit[]> {
    return new Promise((resolve) => {
      pendingRequests.push({ params, resolve })

      if (timeout) {
        clearTimeout(timeout)
      }

      timeout = setTimeout(executePendingRequests, timeoutThreshold)
    })
  }

  async function executePendingRequests() {
    const requests = pendingRequests
    pendingRequests = []

    const params = requests.map((request) => request.params)

    try {
      const response = await axios.get(route("merchant.ad-units.search", { queries: params }))
      const adUnits = response.data.adUnits

      requests.forEach((request, index) => {
        request.resolve(adUnits[index])
      })
    } catch (error) {
      captureException(error)

      requests.forEach((request) => {
        request.resolve([])
      })
    }
  }

  return {
    push,
  }
}

export { createAdUnitSearchQueue }
export default createAdUnitSearchQueue()
